import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'user-custom-logos' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
